import {
  getUserLoginStatus,
  getUserRoleInfoStatus,
  LOGINURL,
} from "@/utils/apis";
import store from "@/store";

export default {
  data() {
    return {
      loginStatus: false,
      roleStatus: false,
      //是否具有仿真实验室权限
      labRole: false,
    };
  },
  methods: {
    async getUserLoginStatus() {
      //获取登录状态
      const data = await getUserLoginStatus();
      //用户登录状态
      this.loginStatus = data.success;
      //用户没登陆过，return
      if (!this.loginStatus) {
        return;
      }
      //网校通用户信息
      const userInfo = store.state.userInfo;
      //用户登录过任意产品，但是没有登过网校通，刷新网校通信息
      if ((!userInfo || !userInfo.userId) && !userInfo.noAuth) {
        window.location.href = LOGINURL;
        return;
      }
      this.getUserRoleInfoStatus();
    },
    //用来判断此用户是否可进入网校通
    async getUserRoleInfoStatus() {
      const data = await getUserRoleInfoStatus();
      if (data.code === 200) {
        this.roleStatus = data.result.enterWxtStatus;
        this.labRole = data.result.labRole;
      }
    },
  },
};
